import { Button, useClipboard } from '@chakra-ui/react';
import React from 'react';
import { FaCheck, FaCopy } from 'react-icons/fa';

type CopyToClipboardProps = { text: string; copiedText?: string };

export const CopyToClipboard = (props: CopyToClipboardProps) => {
  const { hasCopied, onCopy } = useClipboard(props.text);

  return (
    <Button
      w="3xs"
      aria-label="Copy"
      leftIcon={hasCopied ? <FaCheck /> : <FaCopy />}
      onClick={onCopy}
    >
      {hasCopied ? props.copiedText || 'Copied' : 'Copy to clipboard'}
    </Button>
  );
};
